module.exports = __webpack_public_path__ + "img/school.b5e38577.png";